
/* System defined core library */
import { Component, OnInit, Input, Output, EventEmitter, Directive, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/* User defined library/components */
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';
import { UtilityService } from '../../../../shared/services/utility.service';

/* User defined models */
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { BatteryConfig } from '../../../../shared/models/scheduling/batteryConfig.model';
import { Candidate } from '../../../../shared/models/scheduling/candidate.model';


@Component({
  selector: 'app-appointment-detail',
  templateUrl: './appointment-detail.component.html',
  styleUrls: ['./appointment-detail.component.scss'],
})
export class AppointmentDetailComponent implements OnChanges, OnInit {

  /* User defined private/public variables  */
  public IsExpandCollapseAllowed: boolean = false;
  public candidate: Candidate;
  public isRescheduleSlotSelected: boolean;
  public appointmentDetails: AppointmentDetail[];
  public statusMap = {
    "cancelled": "cancelled",
    "scheduled": "scheduled"
  }
  public selectedTranslateLanguage: string = "";
  public isProctored: boolean = false;
  public timezone: any;
  public appointmentStatus: string;

  /* Service subscriptions */
  appointmentSearch$: Subscription;
  appointmentDetailData$: Subscription;
  translateLanguage$: Subscription;
  timezone$: Subscription;

  /* Input-OutPut parameters decalartions */
  @Input() appointmentDetail: AppointmentDetail;
  @Input() sessionId: number;
  @Input() public conditionalClass: string;
  @Input() public targetFlow: string;
  @Input() public showCandidateInfo: boolean = false;
  @Input() confirmation: boolean = false;
  @Input() status: string;
  @Input() batteryConfig: BatteryConfig;
  @Input() selectedAppts: AppointmentDetail[];
  @Input() modalityError: boolean;
  @Output() public IsAppointmentSelected: EventEmitter<any> = new EventEmitter();

  /* Constructor declaration with required injected services */
  constructor(
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService
  ) {

    this.appointmentDetailData$ = selectedExamDetailService.appointmentDetailData.subscribe(
      appointDetailData => {
        this.appointmentDetails = appointDetailData;
      });
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });

    this.timezone$ = this.selectedExamDetailService.timezone.subscribe(timezone => {
      this.timezone = timezone;
    });

  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    this.isRescheduleSlotSelected = this.selectedExamDetailService.isRescheduleSlotSelected;
    if (this.targetFlow == undefined) {
      this.targetFlow = this.selectedExamDetailService.currentTargetFlow;
    }
    if (this.conditionalClass == 'withCheckbox') {
      this.conditionalClass = 'col-12 pl-md-0';
    } else if (this.conditionalClass == 'appointmentLookup') {
      this.conditionalClass = 'col-11 ml-3 ml-md-0';
    } else if (this.conditionalClass == 'appVerification') {
      this.conditionalClass = 'col-11 offset-1  col-md-12 offset-md-0 col-lg-12 offset-lg-0';
    } else {
      this.conditionalClass = 'col-11 offset-1';
    }
    this.isProctored = this.selectedExamDetailService.isProctored;
  }

  ngOnChanges() {
    this.appointmentStatus = (this.appointmentDetail && this.appointmentDetail.status) ? this.appointmentDetail.status.toLowerCase() : this.status.toLowerCase();
  }

  /* Initialize the component & call require methods when component loaded first time. */
  durationToStr(val: number) {
    return this.utilityService.durationToStr(val);
  }
}
